import { z } from "zod";

export const formSchema = z.object({
  business_name: z.string().min(1, "O nome da empresa é obrigatório."),
  email: z.string().email("O email deve ser válido."),
  cel: z
    .string()
    .min(11, "O número de WhatsApp deve ter no mínimo 11 dígitos.")
    .regex(/^\d{11}$/, "O número de WhatsApp deve conter exatamente 11 dígitos."),
});
